import { useState } from "react";
import type { TooltipData } from "@/map/types/map";

export const useMapTooltip = () => {
  const [tooltip, setTooltip] = useState<TooltipData | null>(null);

  const showTooltip = (name: string, x: number, y: number, color?: string) => {
    setTooltip({ name, x, y, color });
  };

  const hideTooltip = () => {
    setTooltip(null);
  };

  return {
    tooltip,
    showTooltip,
    hideTooltip,
  };
};
